module.exports = __webpack_public_path__ + "static/img/215.c6b7277.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200608/215.jpg
// module id = AphO
// module chunks = 0